export default __webpack_public_path__ + "static/media/personal.756e3ac1.png";